import Joi from 'joi'
import errorsResolver from '../../../../validation/schemeUtils'
import {nonCashValidate} from "../../../../validation/scheme/nonCash";

const transferSaledModalSchema = Joi.object({
    payment: Joi.string()
        .required()
        .error(errorsResolver({
            required: `Выберите наличный или безналичный расчёт`,
        })),
    deposit: nonCashValidate,
})

export default transferSaledModalSchema